import Breadcrumb from "../components/Breadcrumb";
import PriceRangeLayer from "../components/child/PriceRangeLayer";

const PriceRange = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title='Price Range Management' />

      {/* PriceRangeLayer */}
      <PriceRangeLayer />
    </>
  );
};

export default PriceRange;
